module.exports = __webpack_public_path__ + "img/ICON_AGE_TBWTTNL.3800efd0.png";